import { jsx as _jsx } from "react/jsx-runtime";
const PageBottomContent = ({ children }) => {
    return (_jsx("div", { className: "page-bottom-content", children: _jsx("div", { className: "container", children: children }) }));
};
export default PageBottomContent;
